// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2iIDB","ranges":"BmiRanges_ranges__3LGtj"};